export const SocialsList: SocialLink[] = [
    // {
    //     name: "socials.telegram",
    //     icon: "telegram",
    //     url: "https://t.me/+UZfPJqqDpD04NDk0.",
    // },
    // {
    //     name: "socials.x",
    //     icon: "x",
    //     // TODO: add link later
    //     url: "#",
    // },
    // TODO: hide for now
    // {
    //     name: "socials.discord",
    //     icon: "discord",
    //     url: "https://www.discord.gg/aerobet",
    // },
    // {
    //     name: "socials.instagram",
    //     icon: "instagram",
    //     url: "https://www.instagram.com/aerobet_casino",
    // },
];

interface SocialLink {
    name: string;
    icon: string;
    url: string;
}
